import React, { ReactNode, useState, useCallback } from 'react';
import Text from '../text';
import { AlignEnum, SizeEnum, WeightEnum } from '../../types';
import SizeToggle from '../size-toggle/SizeToggle';
import { ApplicationSize } from '@getvim-os/types';
import './index.less';

export type SizeType = ApplicationSize;

interface ApplicationTitleProp {
  title: string;
  notifications?: number;
  logoUrl?: string;
  children?: ReactNode;
  onSizeChange?: (size: SizeType) => void;
  initialSize?: SizeType;
  availableSizes?: SizeType[];
  showEmptyGapsCount?: boolean;
}

export default function ApplicationTitle({
  title,
  notifications,
  logoUrl,
  children,
  onSizeChange,
  initialSize = ApplicationSize.CLASSIC,
  availableSizes,
  showEmptyGapsCount = true,
}: ApplicationTitleProp) {
  const [currentSize, setCurrentSize] = useState<SizeType>(initialSize);

  const handleSizeChange = useCallback(
    (size: SizeType) => {
      setCurrentSize(size);
      onSizeChange?.(size);
    },
    [onSizeChange],
  );

  const hasNotifications = notifications !== undefined;
  const showCount = hasNotifications && (notifications || showEmptyGapsCount);

  return (
    <header className="application-title">
      <Text className="label" size={SizeEnum['14px']} align={AlignEnum.left}>
        <h1 className="no-margin no-padding inline-block">
          <Text weight={WeightEnum.semibold} align={AlignEnum.left} inline>
            {title}
          </Text>
        </h1>
        &nbsp;
        {showCount && `(${notifications})`}
      </Text>
      {children}
      {logoUrl ? <img src={logoUrl} className="insurer-logo" alt="data connection logo" /> : null}
      {availableSizes && availableSizes.length > 0 && (
        <div className="size-toggle-container">
          <SizeToggle
            currentSize={currentSize}
            availableSizes={availableSizes}
            onSizeChange={handleSizeChange}
          />
        </div>
      )}
    </header>
  );
}
